import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvCard";
/**
 * A card component
 */
let LvCard = class LvCard extends UIComponent {
};
LvCard = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvCard);
export default LvCard;
//# sourceMappingURL=script.js.map